<template>
  <svg width="79" height="78" viewBox="0 0 79 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M39.5 6C21.2746 6 6.5 20.7746 6.5 39C6.5 57.2254 21.2746 72 39.5 72C57.7254 72 72.5 57.2254 72.5 39C72.5 37.3431 73.8431 36 75.5 36C77.1569 36 78.5 37.3431 78.5 39C78.5 60.5391 61.0391 78 39.5 78C17.9609 78 0.5 60.5391 0.5 39C0.5 17.4609 17.9609 0 39.5 0C41.1569 0 42.5 1.34315 42.5 3C42.5 4.65685 41.1569 6 39.5 6Z" />
  </svg>
</template>

<script>
export default {
  name: 'LoadingSpinner'
}
</script>

<style lang="scss" scoped>
svg {
  fill: var(--color-primary);
  margin-bottom: 48px;
  animation: spinner 1s infinite;
  width: 64px;
}
</style>
